


import { useEffect, useState } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';

//import LogInBackgroundImage from '../images/LogInBackground.jpg';
import PlanHubLogo from '../images/PlanHubLogo.png';

import useUIPresentationMode from './helpers/useUIPresentationMode.js';

import './styles/phcolours.css';


const Welcome = ({ onGuestLogin, onUserLogin }) => {

  const navigate = useNavigate();
  const location = useLocation();

  const redirectTo = new URLSearchParams(location.search).get('redirectTo') || sessionStorage.getItem('redirectTo');

  const { presentationModeSize } = useUIPresentationMode();
  const hideLogo = presentationModeSize === 4 || presentationModeSize === 5;

  //const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.userAgent.includes('Macintosh') && 'ontouchend' in document);

  const [showLogin, setShowLogin] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowLogin(true), 1000); // adjust delay as needed
    return () => clearTimeout(timer);
  }, []);

  const handleLoginClick = () => {
    const query = redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : '';
    navigate(`/login${query}`);
  };

  const handleGuestClick = () => {
    if (redirectTo) {
      onGuestLogin(redirectTo);
    } else {
      onGuestLogin();
    }
  };

  useEffect(() => {

    // If redirectTo exists in sessionStorage but not in the URL, add it.
    // This gives users a clear cue that they’ll be taken somewhere specific after login or guest access.
    const searchParams = new URLSearchParams(location.search);

    if (redirectTo && !searchParams.has('redirectTo')) {

      searchParams.set('redirectTo', redirectTo);
      navigate({ search: searchParams.toString() }, { replace: true });
    }

  }, [redirectTo, location.search, navigate]);


  // Scale this mofo depending on screen size.
  const [scaleFactor, setScaleFactor] = useState(0.9);

  useEffect(() => {
    if (presentationModeSize === 1 || presentationModeSize === 2) {  // Big!
      setScaleFactor(0.85);
    }
    if (presentationModeSize === 3) {  // Not as big.
      setScaleFactor(0.70);
    }
    if (presentationModeSize === 4 || presentationModeSize === 5) {  // Little!
      setScaleFactor(0.70
      );
    }
  }, [presentationModeSize]);



  return (
    <div className="welcome-screen" style={styles.container}>

      {showLogin && (
        <>
          <div style={{
            ...styles.loginBox,
            transform: `scale(${scaleFactor})`,
            transformOrigin: 'center',
            animation: 'fadeIn 1.0s ease-in'
          }}
          >

            {!hideLogo && (
              <img
                src={PlanHubLogo}
                alt="PlanHub Logo"
                style={{ width: '180px', marginTop: '30px', marginBottom: '40px' }}
              />
            )}

            <h1 style={styles.heading}>Welcome to PlanHub</h1>

            <p style={styles.subheading}>
              Teleport plan ideas onto any section in seconds
            </p>

            <div style={styles.buttonGroup}>
              <button style={styles.button} onClick={handleGuestClick}>Continue as Guest</button>
              <button style={{ ...styles.button, backgroundColor: 'var(--phblueaccent)' }} onClick={handleLoginClick}>
                Log In with An Existing Account
              </button>
            </div>

          </div>
        </>
      )}

      {showLogin && isIOS && (
        <div style={styles.appLink}>
          <a
            href="https://apps.apple.com/nz/app/planhub/id1270709538"
            style={styles.appLinkText}
            target="_blank"
            rel="noopener noreferrer"
          >
            PlanHub on iPhone and iPad is better in <span style={styles.underline}>the app</span>
          </a>
        </div>
      )}

    </div>
  );
};


const styles = {
  container: {
    height: '100vh',
    display: 'flex',
    //backgroundImage: `url(${LogInBackgroundImage})`,
    //backgroundSize: 'cover',
    //backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    backgroundColor: '#transparent',
    position: 'relative',
    overflow: 'hidden'
  },
  loginBox: {
    position: 'absolute',
    backdropFilter: 'blur(6px) grayscale(0.3)',
    //WebkitBackdropFilter: 'blur(8px) grayscale(0.4)',
    backgroundColor: 'rgba(50, 50, 50, 0.25)',
    borderRadius: '23px',
    padding: '40px 30px',
    maxWidth: '550px',
    width: '90%',
    //border: '1px solid rgba(255, 255, 255, 0.3)',
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
  },
  heading: {
    fontSize: '35px',
    fontWeight: 800,
    color: 'var(--phblueaccent)',
    textShadow: '0 0px 10px rgba(255, 255, 255, 0.2)',
    marginBottom: '35px',
  },
  subheading: {
    fontSize: '16px',
    fontWeight: 400,
    //color: 'var(--phgrey)',
    color: 'var(--phbluesuperwashedbackground)',
    textShadow: '0 0px 4px rgba(0, 0, 0, 0.6)',
    //mixBlendMode: 'difference',
    marginTop: '-10px',
    marginBottom: '20px',
    textAlign: 'center',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    marginTop: '25px',
  },
  button: {
    padding: '12px 24px',
    marginTop: '20px',
    marginLeft: '10px',
    marginRight: '10px',
    cursor: 'pointer',
    borderRadius: '8px',
    border: 'none',
    backgroundColor: 'var(--phblue)',
    fontSize: '17px',
    color: 'var(--phgrey)',
    fontWeight: '600',
  },
  appLink: {
    position: 'absolute',
    width: '100%',
    bottom: '28px',
    left: '50%',
    transform: 'translateX(-50%)',
    textAlign: 'center',
    pointerEvents: 'auto',
    animation: 'fadeIn 1.0s ease-in',
    animationDelay: '1.0s',           // Small delay to come after the login box.
    animationFillMode: 'both'         // Keeps the opacity: 1 after animating.
  },
  appLinkText: {
    fontSize: '13px',
    color: 'var(--phbluesuperwashedbackground)',
    //textDecoration: 'underline',
    textDecoration: 'none',
    textShadow: '0 2px 3px rgba(0, 0, 0, 0.8)',
    opacity: 0.8,
  },
  underline: {
    textDecoration: 'underline',
  }
};


export default Welcome;


